import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap";

function useFonts() {
  useEffect(() => {
    if (document.querySelector('link[href*="Instrument+Serif"]')) return;
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = FONTS_URL;
    document.head.appendChild(l);
  }, []);
}

const T = {
  g700: "#155c36", g600: "#1b7a47", g500: "#1e9254", g400: "#28b566",
  g200: "#a7d9bc", g100: "#d6f0e3", g50: "#eef8f3",
  n900: "#0f1117", n800: "#1c2130", n700: "#2d3549", n600: "#4a5268",
  n400: "#8a93a8", n300: "#b0b8cc", n200: "#d1d5e0", n150: "#e4e7ef",
  n100: "#eef0f5", n50: "#f7f8fa", white: "#ffffff",
  amber: "#d97706", amberBg: "#fffbeb", amberBorder: "#fde68a",
  blue: "#2563eb", blueBg: "#eff6ff", blueBorder: "#bfdbfe",
  serif: "'Instrument Serif', Georgia, serif",
  sans:  "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
};

const Icon = ({ name, size = 20, color = "currentColor", strokeWidth = 1.6 }) => {
  const paths = {
    ArrowLeft:     <><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></>,
    ArrowRight:    <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
    ChevronRight:  <><path d="m9 18 6-6-6-6"/></>,
    ChevronDown:   <><path d="m6 9 6 6 6-6"/></>,
    ChevronUp:     <><path d="m18 15-6-6-6 6"/></>,
    TrendingUp:    <><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></>,
    Users:         <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></>,
    Globe:         <><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></>,
    Zap:           <><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></>,
    MapPin:        <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></>,
    BadgeCheck:    <><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></>,
    Wallet:        <><path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/><path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></>,
    ShieldCheck:   <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></>,
    Star:          <><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></>,
    Target:        <><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></>,
    BarChart2:     <><line x1="18" x2="18" y1="20" y2="10"/><line x1="12" x2="12" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/></>,
    Layers:        <><path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/></>,
    Phone:         <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.34 3h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></>,
    Mail:          <><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></>,
    CheckCircle:   <><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></>,
    Lock:          <><rect width="18" height="11" x="3" y="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></>,
    Briefcase:     <><rect width="20" height="14" x="2" y="7" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></>,
    Award:         <><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></>,
    Smartphone:    <><rect width="14" height="20" x="5" y="2" rx="2"/><path d="M12 18h.01"/></>,
    Home:          <><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></>,
    Repeat:        <><path d="m17 2 4 4-4 4"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></>,
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      {paths[name]}
    </svg>
  );
};

/* ─────────────────────────────────────────
   DATA
───────────────────────────────────────── */

const METRICS = [
  { value: "700+",     label: "Active JiraniPros",         sub: "Verified service professionals across Kenya" },
  { value: "9",        label: "Service categories",        sub: "Plumbing, electrical, cleaning, and more" },
  { value: "2 cities", label: "Live markets",              sub: "Nairobi and Mombasa, with more cities planned" },
  { value: "24h",      label: "M-Pesa payout",             sub: "Automatic settlement after job completion" },
];

const OPPORTUNITY = [
  {
    icon: "Globe",
    heading: "A continent-scale problem",
    body: "Sub-Saharan Africa has over 1 billion people, a rapidly growing urban middle class, and a home services market that remains almost entirely informal. Finding a reliable plumber, electrician, or cleaner in Nairobi still depends on word of mouth, WhatsApp groups, and luck. Quality is unpredictable. Pricing is opaque. Disputes have no resolution mechanism. JiraniApp is the infrastructure layer this market has been missing.",
  },
  {
    icon: "TrendingUp",
    heading: "Kenya is the right first market",
    body: "Kenya has Africa's most developed mobile payments ecosystem, the highest smartphone penetration in East Africa, and a population of 56 million with a fast-growing urban middle class concentrated in Nairobi and Mombasa. M-Pesa's infrastructure eliminates the payment friction that has held back services marketplaces in other markets. What works in Kenya scales to Uganda, Tanzania, Rwanda, and beyond.",
  },
  {
    icon: "Layers",
    heading: "The gig economy is still early here",
    body: "The global home services marketplace — represented by companies like TaskRabbit, Handy, and Urban Company — has produced multiple billion-dollar outcomes. East Africa is 8–10 years behind in platform adoption. The playbook is validated. The infrastructure is ready. The market is open. JiraniApp is positioned to own this category before it becomes crowded.",
  },
];

const MOAT = [
  {
    icon: "BadgeCheck",
    title: "Trust infrastructure",
    desc: "Identity verification, in-app payments, dispute resolution, and a review system tied to completed bookings are not features — they are barriers to entry. Building trust in a market where informal work is the norm takes years of on-the-ground credibility. We are building it now.",
  },
  {
    icon: "Repeat",
    title: "Network effects on both sides",
    desc: "Every new verified Pro makes the platform more useful to clients. Every new client booking makes JiraniApp more attractive to Pros. Marketplace network effects compound — and in a market where trust is scarce, our verified Pro network is extremely difficult to replicate quickly.",
  },
  {
    icon: "Wallet",
    title: "Payments as infrastructure",
    desc: "M-Pesa integration is not just a feature — it is the reason our payment completion rates are high and our fraud rates are low. We hold funds in escrow and release on completion. This protects clients, guarantees Pros get paid, and earns trust that cash-based competitors cannot offer.",
  },
  {
    icon: "Smartphone",
    title: "Phone-first, low-friction design",
    desc: "JiraniApp was built for a user who has a mid-range Android and intermittent data. No email required. No desktop needed. Signup takes under five minutes. Booking takes under three. The product works for the actual market, not a hypothetical one.",
  },
];

const TEAM = [
  {
    initials: "AK",
    name: "Founder, CEO",
    background: "Background in product and marketplace growth. Previously at a leading East African fintech.",
    colorBg: T.g50, colorText: T.g700, colorBorder: T.g100,
  },
  {
    initials: "BM",
    name: "Co-founder, CTO",
    background: "Full-stack engineering background. Built and scaled consumer platforms in Kenya and the UK.",
    colorBg: T.blueBg, colorText: T.blue, colorBorder: T.blueBorder,
  },
  {
    initials: "CN",
    name: "Head of Operations",
    background: "Operations and supply-side growth. Deep experience in Nairobi's professional services ecosystem.",
    colorBg: T.amberBg, colorText: T.amber, colorBorder: T.amberBorder,
  },
];

const FAQS = [
  {
    q: "What markets is JiraniApp currently live in?",
    a: "JiraniApp is currently live in Nairobi and Mombasa. We have active Pro supply and client bookings in both cities. Our roadmap includes Kisumu, Nakuru, and Dar es Salaam. Expansion pace is tied to Pro supply quality — we grow when we can maintain the verification and trust standards the platform is built on.",
  },
  {
    q: "How does JiraniApp make money?",
    a: "JiraniApp charges a platform commission of 10–15% on completed bookings, depending on service category. This fee is charged to the Pro and covers payment processing, client acquisition, Trust and Safety operations, and platform infrastructure. There are no subscription fees for Pros or Clients. Revenue scales directly with GMV.",
  },
  {
    q: "What is the long-term vision beyond home services?",
    a: "Home services is the entry point — high frequency, high trust requirement, large addressable market. The longer-term opportunity is to become the dominant platform for informal-to-formal professional services across urban East Africa, extending into adjacent verticals where the same trust and payment infrastructure applies: personal care, tutoring, wellness, and logistics.",
  },
  {
    q: "How does JiraniApp approach Pro quality and retention?",
    a: "Quality starts at onboarding with identity verification and background checks. It is maintained through a review system tied exclusively to completed bookings, a dispute resolution process that is fair to both sides, and performance visibility in the Pro dashboard. Pros who deliver consistent quality earn more bookings. The incentive structure is designed so that quality is rewarded, not just volume.",
  },
  {
    q: "Is JiraniApp raising right now?",
    a: "We are open to conversations with investors who understand African consumer markets and have conviction in the infrastructure opportunity. If that describes you, we would rather have a conversation than answer this question on a website. Use the form on this page to reach us directly.",
  },
];

/* ─────────────────────────────────────────
   COMPONENTS
───────────────────────────────────────── */

function MetricCard({ value, label, sub }) {
  return (
    <div style={{
      padding: "28px 24px",
      borderRight: `1px solid ${T.n100}`,
      flex: "1 1 160px",
    }}>
      <div style={{
        fontFamily: T.serif, fontSize: "clamp(32px,5vw,44px)", fontWeight: 400,
        color: T.g600, letterSpacing: "-0.03em", lineHeight: 1, marginBottom: 8,
      }}>{value}</div>
      <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 12, color: T.n400, lineHeight: 1.5 }}>{sub}</div>
    </div>
  );
}

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: `1px solid ${T.n100}` }}>
      <button onClick={() => setOpen(o => !o)} style={{
        width: "100%", display: "flex", justifyContent: "space-between",
        alignItems: "center", padding: "22px 0", background: "none",
        border: "none", cursor: "pointer", fontFamily: T.sans,
        textAlign: "left", gap: 20,
      }}>
        <span style={{ fontSize: 15, fontWeight: 400, color: T.n800, lineHeight: 1.5, letterSpacing: "-0.01em" }}>{q}</span>
        <span style={{
          width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
          border: `1px solid ${open ? T.g500 : T.n200}`,
          background: open ? T.g500 : "transparent",
          color: open ? T.white : T.n400,
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all .22s cubic-bezier(.4,0,.2,1)",
          transform: open ? "rotate(45deg)" : "none",
          fontSize: 18, fontWeight: 300,
        }}>+</span>
      </button>
      <div style={{ overflow: "hidden", maxHeight: open ? 400 : 0, transition: "max-height .32s cubic-bezier(.4,0,.2,1)" }}>
        <p style={{ margin: "0 0 22px", fontSize: 15, color: T.n600, lineHeight: 1.8, paddingRight: 48, fontFamily: T.sans }}>{a}</p>
      </div>
    </div>
  );
}

/* Expression of interest form */
function EOIForm() {
  const [form, setForm] = useState({ name: "", firm: "", email: "", type: "", message: "" });
  const [focused, setFocused] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const set = (k, v) => { setForm(f => ({ ...f, [k]: v })); setErrors(e => ({ ...e, [k]: "" })); };

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = "Please enter your name.";
    if (!form.email.trim())   e.email   = "Please enter your email address.";
    if (!form.type)           e.type    = "Please select an investor type.";
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setSubmitted(true);
  };

  const inputStyle = (field) => ({
    width: "100%", padding: "13px 14px",
    border: `1.5px solid ${errors[field] ? "#dc2626" : focused === field ? T.g500 : T.n200}`,
    borderRadius: 10, fontSize: 14, outline: "none",
    fontFamily: T.sans, color: T.n900, background: T.white,
    boxShadow: focused === field && !errors[field] ? `0 0 0 3px ${T.g100}` : "none",
    transition: "all .18s",
  });

  if (submitted) {
    return (
      <div style={{ textAlign: "center", padding: "52px 20px" }}>
        <div style={{
          width: 60, height: 60, borderRadius: "50%",
          background: T.g50, border: `2px solid ${T.g200}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 22px",
        }}>
          <Icon name="CheckCircle" size={28} color={T.g500} strokeWidth={1.8} />
        </div>
        <h3 style={{ fontFamily: T.serif, fontSize: 26, fontWeight: 400, color: T.n900, margin: "0 0 10px", letterSpacing: "-0.02em" }}>
          Thank you, {form.name.split(" ")[0]}
        </h3>
        <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.75, margin: "0 auto", maxWidth: 380 }}>
          We have received your expression of interest. Someone from the JiraniApp team will
          be in touch at <strong style={{ color: T.n800 }}>{form.email}</strong> within 3 business days.
        </p>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* Row: name + firm */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 }}>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
            Your name <span style={{ color: "#dc2626" }}>*</span>
          </label>
          <input value={form.name} onChange={e => set("name", e.target.value)}
            onFocus={() => setFocused("name")} onBlur={() => setFocused(null)}
            placeholder="Full name"
            style={inputStyle("name")} />
          {errors.name && <p style={{ margin: "4px 0 0", fontSize: 12, color: "#dc2626", fontFamily: T.sans }}>{errors.name}</p>}
        </div>
        <div>
          <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
            Firm or organisation
          </label>
          <input value={form.firm} onChange={e => set("firm", e.target.value)}
            onFocus={() => setFocused("firm")} onBlur={() => setFocused(null)}
            placeholder="Fund or company name (optional)"
            style={inputStyle("firm")} />
        </div>
      </div>

      {/* Email */}
      <div>
        <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
          Email address <span style={{ color: "#dc2626" }}>*</span>
        </label>
        <input value={form.email} onChange={e => set("email", e.target.value)}
          onFocus={() => setFocused("email")} onBlur={() => setFocused(null)}
          placeholder="you@fund.com" type="email"
          style={inputStyle("email")} />
        {errors.email && <p style={{ margin: "4px 0 0", fontSize: 12, color: "#dc2626", fontFamily: T.sans }}>{errors.email}</p>}
      </div>

      {/* Investor type */}
      <div>
        <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
          Investor type <span style={{ color: "#dc2626" }}>*</span>
        </label>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {["Venture capital", "Angel investor", "Family office", "Strategic / corporate", "Other"].map(type => {
            const active = form.type === type;
            return (
              <button key={type} onClick={() => set("type", type)} style={{
                padding: "8px 14px", borderRadius: 99, cursor: "pointer",
                fontFamily: T.sans, fontSize: 13, fontWeight: active ? 600 : 400,
                border: `1.5px solid ${errors.type ? "#dc2626" : active ? T.g500 : T.n200}`,
                background: active ? T.g500 : T.white,
                color: active ? T.white : T.n600,
                transition: "all .15s",
              }}>
                {type}
              </button>
            );
          })}
        </div>
        {errors.type && <p style={{ margin: "6px 0 0", fontSize: 12, color: "#dc2626", fontFamily: T.sans }}>{errors.type}</p>}
      </div>

      {/* Message */}
      <div>
        <label style={{ fontSize: 12, fontWeight: 600, color: T.n700, display: "block", marginBottom: 6, fontFamily: T.sans }}>
          Anything you want us to know
        </label>
        <textarea value={form.message} onChange={e => set("message", e.target.value)}
          onFocus={() => setFocused("message")} onBlur={() => setFocused(null)}
          placeholder="Your focus areas, relevant portfolio companies, what drew you to JiraniApp — anything helpful for context."
          rows={4}
          style={{
            ...inputStyle("message"),
            resize: "vertical", lineHeight: 1.65, minHeight: 100,
          }} />
      </div>

      {/* Confidentiality note */}
      <div style={{
        display: "flex", gap: 10, alignItems: "flex-start",
        padding: "12px 14px", borderRadius: 10,
        background: T.n50, border: `1px solid ${T.n150}`,
      }}>
        <Icon name="Lock" size={14} color={T.n400} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} />
        <p style={{ margin: 0, fontSize: 12, color: T.n500, lineHeight: 1.65, fontFamily: T.sans }}>
          Your enquiry is confidential. We do not share investor contact details with third parties.
          Submitting this form does not constitute a commitment or offer on either side.
        </p>
      </div>

      <button onClick={handleSubmit} style={{
        padding: "14px", background: T.g500, color: T.white,
        border: "none", borderRadius: 11, fontSize: 15, fontWeight: 600,
        cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
        display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
        transition: "background .15s",
      }}
        onMouseEnter={e => e.currentTarget.style.background = T.g600}
        onMouseLeave={e => e.currentTarget.style.background = T.g500}>
        Send expression of interest
        <Icon name="ArrowRight" size={16} color={T.white} strokeWidth={2} />
      </button>
    </div>
  );
}

/* ══ MAIN PAGE ══ */
export default function InvestorRelationsPage() {
  useFonts();
  const navigate = useNavigate();

  return (
    <div style={{ fontFamily: T.sans, background: T.white, minHeight: "100vh", color: T.n900, paddingBottom: 100 }}>
      <style>{`
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { display: none; }
      `}</style>

      {/* ── Nav ── */}
      <div style={{ padding: "16px 24px", borderBottom: `1px solid ${T.n100}`, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button onClick={() => navigate(-1)} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "none", border: "none", cursor: "pointer",
          color: T.n400, fontSize: 13, fontFamily: T.sans, padding: 0,
        }}
          onMouseEnter={e => e.currentTarget.style.color = T.n800}
          onMouseLeave={e => e.currentTarget.style.color = T.n400}>
          <Icon name="ArrowLeft" size={14} strokeWidth={2} />
          Back
        </button>
        <button onClick={() => {
          document.getElementById("eoi-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }} style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: T.g500, border: "none", cursor: "pointer",
          color: T.white, fontSize: 13, fontFamily: T.sans,
          padding: "8px 16px", borderRadius: 8, fontWeight: 600,
        }}
          onMouseEnter={e => e.currentTarget.style.background = T.g600}
          onMouseLeave={e => e.currentTarget.style.background = T.g500}>
          Get in touch
          <Icon name="ArrowRight" size={13} strokeWidth={2.2} color={T.white} />
        </button>
      </div>

      {/* ══ HERO ══ */}
      <div style={{ padding: "clamp(64px,9vw,112px) 20px clamp(56px,7vw,88px)", borderBottom: `1px solid ${T.n100}` }}>
        <div style={{ maxWidth: 720, margin: "0 auto" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 24 }}>
            <Icon name="TrendingUp" size={13} color={T.g500} strokeWidth={2.2} />
            Investor Relations
          </div>
          <h1 style={{
            fontFamily: T.serif, fontSize: "clamp(42px,8vw,76px)", fontWeight: 400,
            margin: "0 0 24px", lineHeight: 1.02, color: T.n900,
            letterSpacing: "-0.035em", maxWidth: 680,
          }}>
            Building the trust layer for home services{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>across Africa</em>
          </h1>
          <p style={{ fontSize: "clamp(16px,2.2vw,19px)", color: T.n600, lineHeight: 1.75, margin: "0 0 40px", maxWidth: 560 }}>
            JiraniApp is a verified marketplace connecting homeowners with trusted local service
            professionals in Kenya. We are building the infrastructure — trust, payments,
            and reputation — that the continent's informal services economy has never had.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <button onClick={() => {
              document.getElementById("eoi-form")?.scrollIntoView({ behavior: "smooth", block: "start" });
            }} style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: T.g500, color: T.white, border: "none",
              padding: "15px 30px", borderRadius: 11, fontSize: 15, fontWeight: 600,
              cursor: "pointer", fontFamily: T.sans, letterSpacing: "0.01em",
            }}
              onMouseEnter={e => e.currentTarget.style.background = T.g600}
              onMouseLeave={e => e.currentTarget.style.background = T.g500}>
              Express interest
              <Icon name="ArrowRight" size={16} color={T.white} strokeWidth={2} />
            </button>
            <span style={{ fontSize: 13, color: T.n400 }}>All enquiries are confidential</span>
          </div>
        </div>
      </div>

      {/* ══ METRICS STRIP ══ */}
      <div style={{ borderBottom: `1px solid ${T.n100}`, overflowX: "auto" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", minWidth: 480 }}>
          {METRICS.map((m, i) => (
            <div key={i} style={{
              flex: "1 1 0", padding: "28px 24px",
              borderRight: i < METRICS.length - 1 ? `1px solid ${T.n100}` : "none",
            }}>
              <div style={{
                fontFamily: T.serif, fontSize: "clamp(26px,4vw,38px)", fontWeight: 400,
                color: T.g600, letterSpacing: "-0.03em", lineHeight: 1, marginBottom: 8,
              }}>{m.value}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: T.n900, marginBottom: 3 }}>{m.label}</div>
              <div style={{ fontSize: 12, color: T.n400, lineHeight: 1.5 }}>{m.sub}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ maxWidth: 720, margin: "0 auto", padding: "0 20px" }}>

        {/* ══ THE OPPORTUNITY ══ */}
        <div style={{ paddingTop: "clamp(56px,8vw,88px)", marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            The opportunity
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            A large, fragmented market with no{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>dominant player</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 40px", lineHeight: 1.7, maxWidth: 560 }}>
            The conditions for a category-defining marketplace exist right now.
            The window is open. The infrastructure is ready. The timing is right.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {OPPORTUNITY.map((item, i) => (
              <div key={i} style={{
                display: "flex", gap: 22, padding: "32px 0",
                borderBottom: i < OPPORTUNITY.length - 1 ? `1px solid ${T.n100}` : "none",
              }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 14, flexShrink: 0,
                  background: T.g50, border: `1.5px solid ${T.g100}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginTop: 4,
                }}>
                  <Icon name={item.icon} size={21} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <h3 style={{
                    fontFamily: T.serif, fontSize: "clamp(19px,3vw,23px)", fontWeight: 400,
                    color: T.n900, margin: "0 0 10px", letterSpacing: "-0.02em", lineHeight: 1.25,
                  }}>{item.heading}</h3>
                  <p style={{ fontSize: 15, color: T.n600, lineHeight: 1.8, margin: 0 }}>{item.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ BUSINESS MODEL ══ */}
        <div style={{ marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Business model
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            Simple, scalable,{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>transaction-based</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 36px", lineHeight: 1.7 }}>
            Revenue is earned only when value is delivered. No subscriptions, no listings fees, no pay-to-rank.
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
            {[
              {
                icon: "BarChart2",
                label: "Commission on completed bookings",
                desc: "JiraniApp earns 10–15% of each completed job, charged to the Pro. The rate varies by service category. There are zero upfront costs for Pros or Clients — we make money only when a successful transaction happens.",
                highlight: "10–15% per completed job",
              },
              {
                icon: "Repeat",
                label: "High repeat booking rate",
                desc: "Home services are inherently recurring — cleaning, gardening, and plumbing are not one-time events. Clients who find a reliable Pro rebook repeatedly. Rebooking revenue requires no incremental acquisition cost.",
                highlight: "Recurring by nature",
              },
              {
                icon: "Layers",
                label: "Future revenue layers",
                desc: "As the platform scales, additional revenue opportunities include Pro subscription tiers for premium placement, insurance and protection products for clients, financial services for Pros (income advances, insurance), and B2B services for property managers and landlords.",
                highlight: "Multiple expansion paths",
              },
            ].map((item, i) => (
              <div key={i} style={{
                padding: "24px", borderRadius: 16,
                border: `1px solid ${T.n150}`, background: T.n50,
                display: "flex", flexDirection: "column", gap: 14,
              }}>
                <div style={{
                  width: 42, height: 42, borderRadius: 12,
                  background: T.white, border: `1px solid ${T.n150}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={item.icon} size={19} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{
                    display: "inline-block", fontSize: 11, fontWeight: 700,
                    color: T.g600, background: T.g50, border: `1px solid ${T.g100}`,
                    borderRadius: 99, padding: "3px 10px", marginBottom: 10,
                    letterSpacing: "0.04em",
                  }}>{item.highlight}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 8, lineHeight: 1.3 }}>{item.label}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.75, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ MOAT ══ */}
        <div style={{ marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Competitive advantages
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            What makes this{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>difficult to replicate</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 36px", lineHeight: 1.7 }}>
            The most important moats in marketplace businesses are not technical. They are trust, network effects, and time.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
            {MOAT.map((item, i) => (
              <div key={i} style={{
                padding: "24px 22px", borderRadius: 14,
                border: `1px solid ${T.n150}`, background: T.white,
                display: "flex", gap: 16, alignItems: "flex-start",
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 11, flexShrink: 0,
                  background: T.g50, border: `1px solid ${T.g100}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={item.icon} size={18} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 7, lineHeight: 1.3 }}>{item.title}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.75, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TRACTION ══ */}
        <div style={{ marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Traction
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            Real usage. Real revenue.{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>Real market fit.</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 36px", lineHeight: 1.7 }}>
            We are not pre-product. We are not pre-revenue. We have verified professionals, completed bookings, and paying clients in two cities.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 0, borderRadius: 16, border: `1px solid ${T.n150}`, overflow: "hidden" }}>
            {[
              { icon: "BadgeCheck", label: "700+ verified JiraniPros",         desc: "Identity-verified service professionals live and taking bookings in Nairobi and Mombasa across 9 service categories." },
              { icon: "Home",       label: "Two live cities",                   desc: "Active supply and client demand in both Nairobi and Mombasa. Expansion to additional cities is budgeted and planned." },
              { icon: "Wallet",     label: "M-Pesa integrated payments",        desc: "Fully operational payment escrow and Pro payout system. Clients pay in-app; Pros receive M-Pesa disbursements within 24 hours of job completion." },
              { icon: "Star",       label: "Verified review system",            desc: "Review and rating system tied exclusively to completed bookings — no anonymous or unverified reviews. Building the trust signal that compounds over time." },
              { icon: "ShieldCheck",label: "Trust and Safety infrastructure",   desc: "In-app dispute resolution, identity verification, and a trained Trust and Safety team handling client and Pro issues. The operational layer is built." },
            ].map((item, i, arr) => (
              <div key={i} style={{
                display: "flex", gap: 18, padding: "22px 24px", alignItems: "flex-start",
                background: i % 2 === 0 ? T.white : T.n50,
                borderBottom: i < arr.length - 1 ? `1px solid ${T.n100}` : "none",
              }}>
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: T.g50, border: `1px solid ${T.g100}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                  <Icon name={item.icon} size={17} color={T.g500} strokeWidth={1.6} />
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 5 }}>{item.label}</div>
                  <p style={{ fontSize: 14, color: T.n600, lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ══ TEAM ══ */}
        <div style={{ marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            The team
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 8px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            Built by people who understand{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>this market</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 36px", lineHeight: 1.7 }}>
            The founding team combines marketplace product experience, engineering depth,
            and on-the-ground knowledge of how professional services work in East Africa.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 14 }}>
            {TEAM.map((member, i) => (
              <div key={i} style={{
                padding: "24px 20px", borderRadius: 14,
                border: `1px solid ${T.n150}`, background: T.white,
                display: "flex", flexDirection: "column", gap: 14,
              }}>
                <div style={{
                  width: 52, height: 52, borderRadius: "50%",
                  background: member.colorBg, border: `2px solid ${member.colorBorder}`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 17, fontWeight: 700, color: member.colorText,
                  fontFamily: T.sans, letterSpacing: "0.04em",
                }}>{member.initials}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: T.n900, marginBottom: 6 }}>{member.name}</div>
                  <p style={{ fontSize: 13, color: T.n600, lineHeight: 1.7, margin: 0 }}>{member.background}</p>
                </div>
              </div>
            ))}
          </div>
          <div style={{
            marginTop: 18, padding: "16px 20px", borderRadius: 12,
            background: T.amberBg, border: `1px solid ${T.amberBorder}`,
            display: "flex", gap: 10, alignItems: "flex-start",
          }}>
            <span style={{ fontSize: 15, flexShrink: 0, marginTop: 1 }}>ℹ</span>
            <p style={{ fontSize: 13, color: T.amberText || "#92400e", margin: 0, lineHeight: 1.65, fontFamily: T.sans }}>
              Full team backgrounds and LinkedIn profiles are shared with investors as part of the introduction process.
              Reach out via the form below to get started.
            </p>
          </div>
        </div>

        {/* ══ FAQ ══ */}
        <div style={{ marginBottom: "clamp(56px,8vw,80px)" }}>
          <p style={{ fontSize: 11, fontWeight: 700, color: T.g500, letterSpacing: "0.1em", textTransform: "uppercase", margin: "0 0 12px" }}>
            Common questions
          </p>
          <h2 style={{
            fontFamily: T.serif, fontSize: "clamp(28px,5vw,42px)", fontWeight: 400,
            color: T.n900, margin: "0 0 4px", letterSpacing: "-0.03em", lineHeight: 1.1,
          }}>
            Before you{" "}
            <em style={{ fontStyle: "italic", color: T.g600 }}>reach out</em>
          </h2>
          <p style={{ fontSize: 16, color: T.n400, margin: "0 0 8px", lineHeight: 1.7 }}>
            Answers to what most investors ask us first.
          </p>
          <div style={{ marginTop: 8 }}>
            {FAQS.map((f, i) => <FaqItem key={i} {...f} />)}
          </div>
        </div>

        {/* ══ EOI FORM ══ */}
        <div id="eoi-form" style={{ scrollMarginTop: 32, marginBottom: 20 }}>
          <div style={{
            borderRadius: 20, border: `1.5px solid ${T.n150}`,
            overflow: "hidden",
          }}>
            {/* Form header */}
            <div style={{
              padding: "clamp(32px,5vw,48px) clamp(24px,4vw,40px) 32px",
              background: `linear-gradient(135deg, ${T.g50} 0%, ${T.n50} 100%)`,
              borderBottom: `1px solid ${T.n150}`,
            }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: T.g600, fontSize: 12, fontWeight: 600, letterSpacing: "0.09em", textTransform: "uppercase", marginBottom: 18 }}>
                <Icon name="Briefcase" size={13} color={T.g500} strokeWidth={2.2} />
                Expression of interest
              </div>
              <h2 style={{
                fontFamily: T.serif, fontSize: "clamp(28px,5vw,40px)", fontWeight: 400,
                color: T.n900, margin: "0 0 12px", letterSpacing: "-0.03em", lineHeight: 1.15,
              }}>
                Let's start a{" "}
                <em style={{ fontStyle: "italic", color: T.g600 }}>conversation</em>
              </h2>
              <p style={{ fontSize: 15, color: T.n600, margin: 0, lineHeight: 1.75, maxWidth: 480 }}>
                Fill in the form below and someone from the JiraniApp founding team will follow up
                directly within 3 business days. No intermediaries, no automated responses.
              </p>
            </div>

            {/* Form body */}
            <div style={{ padding: "clamp(28px,4vw,40px) clamp(24px,4vw,40px)" }}>
              <EOIForm />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}